'use strict';

exports.__esModule = true;
exports.getSkinName = getSkinName;
exports.convertStyleParamForViewerType = convertStyleParamForViewerType;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_STYLE_PARAMS = {
  backgroundColor: 'bg',
  foregroundColor: 'fg',
  borderColor: 'brd',
  borderWidth: 'brw',
  borderRadius: 'rd',
  color: 'txt'
};

var STYLE_PARAMS_OVERRIDES = {
  'wysiwyg.viewer.components.inputs.FileUploader': {
    backgroundColor: 'btn_bg',
    borderColor: 'btn_brd',
    borderWidth: 'btn_brw',
    borderRadius: 'btn_rd',
    color: 'btn_txt'
  },
  'wixui.FileUploaderNew': {
    backgroundColor: 'btn_bg',
    borderColor: 'btn_brd',
    borderWidth: 'btn_brw',
    borderRadius: 'btn_rd',
    color: 'btn_txt'
  },
  'wixui.ProgressBar': {
    backgroundColor: 'barBackgroundColor',
    foregroundColor: 'barForegroundColor',
    borderColor: 'borderColor',
    borderWidth: 'borderSize',
    borderRadius: 'borderRadius'
  },
  'wixui.SignatureInput': {
    backgroundColor: 'padBackground',
    borderColor: 'padBorderColor',
    borderWidth: 'padBorderWidth'
  },
  'wixui.SearchBox': {
    backgroundColor: 'inputBackgroundColor',
    borderColor: 'inputBorderColor',
    borderWidth: 'inputBorderWidth',
    borderRadius: 'inputBorderRadius',
    color: 'inputTextColor'
  }
};

var SKIN_TYPE_EXPORTS = {
  'skins.input.RadioGroupDefaultSkin': 'wysiwyg.common.components.radio.viewer.skins.RadioButtonDefaultSkin'
};

function getSkinName(skinType) {
  return _lodash2.default.get(SKIN_TYPE_EXPORTS, skinType) || skinType;
}

function convertStyleParamForViewerType(viewerType, styleParam) {
  var overrides = _lodash2.default.get(STYLE_PARAMS_OVERRIDES, viewerType);
  var styleParamMap = overrides ? overrides : DEFAULT_STYLE_PARAMS;
  return _lodash2.default.get(styleParamMap, styleParam, styleParam);
}
//# sourceMappingURL=widgetUtils.js.map